// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"342":"5c0b189e","644":"29c1a539"}[chunkId] || chunkId) + "." + {"68":"efac5b994c354fcb","342":"27936afe909eeb90","416":"1b812f94eab31f7c","644":"ef3a096defcb6b1f"}[chunkId] + ".js";
};